import React from 'react';

// 20px schematic marks for the marketing nav. Same vocabulary as the
// homepage What's new art: hairline structure, teal for the live part,
// gold only on a gate or a commit. Decorative — the row label is the name.

function Mark({ children }) {
  return (
    <svg viewBox="0 0 20 20" focusable="false">
      {children}
    </svg>
  );
}

const MARKS = {
  overview: () => (
    <Mark>
      <circle cx="4.2" cy="10" r="1.7" className="wn-surf-fill" />
      <path d="M6.2 10 h2.4" className="wn-line" />
      <path d="M8.6 10 l2.3 -2.3 l2.3 2.3 l-2.3 2.3 z" className="wn-gold" />
      <path d="M13.4 10 h2.2" className="wn-line" />
    </Mark>
  ),
  nqube: () => (
    <Mark>
      <circle cx="4.6" cy="10" r="2" className="wn-fill" />
      <circle cx="4.6" cy="10" r="0.9" className="wn-surf-fill" />
      <path d="M6.8 10 H10.2" className="wn-line" />
      <path d="M10.2 10 L13.6 6" className="wn-line" />
      <path d="M10.2 10 L13.6 14" className="wn-line" />
      <circle cx="15" cy="5.4" r="1.7" className="wn-fill" />
      <circle cx="15" cy="14.6" r="1.7" className="wn-surf-fill" />
    </Mark>
  ),
  // Training Center: a loss curve falling to the right, the gate (gold) in
  // front of the last, expensive stretch.
  training: () => (
    <Mark>
      <path d="M3 15.2 h14" className="wn-line" />
      <path d="M3.6 4.6 C6 11.5, 8.2 12.4, 11 12.8" className="wn-on" />
      <path d="M11.6 12.8 l1.6 -1.6 l1.6 1.6 l-1.6 1.6 z" className="wn-gold" />
      <path d="M15.2 12.8 h1.6" className="wn-line" />
    </Mark>
  ),
  agentos: () => (
    <Mark>
      <path d="M3.2 10 L7.4 6 L11.6 10 L7.4 14 Z" className="wn-gold" />
      <path d="M12.4 10.3 l1.7 1.7 l3.3 -3.6" className="wn-on" />
    </Mark>
  ),
  'agent-io': () => (
    <Mark>
      <rect x="3" y="3.4" width="14" height="13.2" rx="2" className="wn-fill" />
      <circle cx="7.2" cy="8" r="1.7" className="wn-surf-fill" />
      <path d="M11 7.1 h4.2 M11 9.3 h3" className="wn-line" />
      <path d="M5.4 13.2 h9.2" className="wn-line" />
    </Mark>
  ),
  'nventr-agent': () => (
    <Mark>
      <path d="M3.2 4.2 h11.2 a1.8 1.8 0 0 1 1.8 1.8 v4.6 a1.8 1.8 0 0 1 -1.8 1.8 H8 l-2.6 2.6 v-2.6 H3.2 a1.8 1.8 0 0 1 -1.8 -1.8 V6 a1.8 1.8 0 0 1 1.8 -1.8 z" className="wn-fill" />
      <circle cx="6.6" cy="8.6" r="0.9" className="wn-surf-fill" />
      <circle cx="9.6" cy="8.6" r="0.9" className="wn-muted" />
      <circle cx="12.6" cy="8.6" r="0.9" className="wn-muted" />
    </Mark>
  ),
  athena: () => (
    <Mark>
      <path d="M3.2 16.2 h13.6" className="wn-line" />
      <rect x="4.4" y="10" width="2.6" height="5.6" rx="0.5" className="wn-muted" />
      <rect x="8.7" y="5.6" width="2.6" height="10" rx="0.5" className="wn-surf-fill" />
      <rect x="13" y="8.2" width="2.6" height="7.4" rx="0.5" className="wn-muted" />
    </Mark>
  ),
  listen: () => (
    <Mark>
      <path d="M3.4 11.2 h13.2 v3.2 a1.6 1.6 0 0 1 -1.6 1.6 h-10 a1.6 1.6 0 0 1 -1.6 -1.6 z" className="wn-fill" />
      <path d="M10 3 v6.4" className="wn-on" />
      <path d="M7.5 7.2 L10 9.7 L12.5 7.2" className="wn-on" />
    </Mark>
  ),
  reachout: () => (
    <Mark>
      <path d="M3.2 10.4 L16.6 3.8 L12.4 16.4 L9.4 11.2 Z" className="wn-fill" />
      <path d="M9.6 11.1 L16.6 3.8" className="wn-on" />
    </Mark>
  ),
  devops: () => (
    <Mark>
      <path d="M2.4 11 H5.8 L7.8 6.2 L10.6 14.8 L12.6 9.2 H17.6" className="wn-on" />
    </Mark>
  ),
  loop: () => (
    <Mark>
      <path d="M10 4.4 a5.2 5.2 0 1 0 4.4 2.4" className="wn-line" />
      <path d="M14.2 3.4 v3.4 h-3.4" className="wn-gold" />
    </Mark>
  ),
  kit: () => (
    <Mark>
      <path d="M10 3 L16.6 6.4 V13.6 L10 17 L3.4 13.6 V6.4 Z" className="wn-fill" />
      <path d="M10 10.2 L16.6 6.4 M10 10.2 L3.4 6.4 M10 10.2 V17" className="wn-line" />
      <circle cx="10" cy="8" r="1" className="wn-surf-fill" />
    </Mark>
  ),
  'dev-console': () => (
    <Mark>
      <rect x="2.6" y="3.4" width="14.8" height="13.2" rx="1.8" className="wn-fill" />
      <path d="M2.6 7.2 h14.8" className="wn-line" />
      <circle cx="5" cy="5.3" r="0.7" className="wn-surf-fill" />
      <path d="M5.8 11.2 l1.8 1.5 l-1.8 1.5" className="wn-on" />
      <path d="M9.2 14.2 h4.2" className="wn-line" />
    </Mark>
  ),
  foundation: () => (
    <Mark>
      <path d="M3.2 5.4 h13.6 l-1.3 2.3 H4.5 Z" className="wn-fill" />
      <path d="M4.2 8.8 h11.6 l-1.3 2.3 H5.5 Z" className="wn-fill" />
      <path d="M5.2 12.2 h9.6 l-1.3 2.5 H6.5 Z" className="wn-gold-fill" />
    </Mark>
  ),
  assurance: () => (
    <Mark>
      <path d="M10 2.6 L16.2 5.1 V10.4 c0 3.2 -2.6 5.1 -6.2 6.8 c-3.6 -1.7 -6.2 -3.6 -6.2 -6.8 V5.1 Z" className="wn-fill" />
      <path d="M7.3 10.2 l1.8 1.8 l3.7 -4" className="wn-on" />
    </Mark>
  ),
  hardware: () => (
    <Mark>
      <path d="M8 6 V3.2 M12 6 V3.2 M8 14 v2.8 M12 14 v2.8 M6 8 H3.2 M6 12 H3.2 M14 8 h2.8 M14 12 h2.8" className="wn-line" />
      <rect x="6" y="6" width="8" height="8" rx="1.2" className="wn-fill" />
      <rect x="8.2" y="8.2" width="3.6" height="3.6" rx="0.4" className="wn-surf-fill" />
    </Mark>
  ),
  partners: () => (
    <Mark>
      <circle cx="5.2" cy="10" r="2.4" className="wn-fill" />
      <circle cx="14.8" cy="10" r="2.4" className="wn-fill" />
      <path d="M7.6 10 h4.8" className="wn-on" />
    </Mark>
  ),
  gridos: () => (
    <Mark>
      <rect x="3" y="3" width="5.8" height="5.8" rx="1" className="wn-fill" />
      <rect x="11.2" y="3" width="5.8" height="5.8" rx="1" className="wn-surf-fill" />
      <rect x="3" y="11.2" width="5.8" height="5.8" rx="1" className="wn-fill" />
      <rect x="11.2" y="11.2" width="5.8" height="5.8" rx="1" className="wn-fill" />
    </Mark>
  ),
  // Hairline people for the right-side Sales / Support links. No color emoji.
  sales: () => (
    <Mark>
      <circle cx="7.2" cy="6.2" r="2.15" className="wn-fill" />
      <path d="M3.4 15.6 c.7 -3.1 2 -4.5 3.8 -4.5 s3.1 1.4 3.8 4.5" className="wn-line" />
      <rect x="12.4" y="9.2" width="4.4" height="3.3" rx="0.6" className="wn-fill" />
      <path d="M13.6 9.2 v-.7 a.9 .9 0 0 1 1.8 0 V9.2" className="wn-line" />
    </Mark>
  ),
  support: () => (
    <Mark>
      <path d="M4.6 6.6 a3.2 3.2 0 0 1 6.4 0" className="wn-line" />
      <circle cx="7.8" cy="7.6" r="2.05" className="wn-fill" />
      <path d="M3.8 15.8 c.8 -3.1 2.1 -4.5 4 -4.5 s3.2 1.4 4 4.5" className="wn-line" />
      <circle cx="4.5" cy="8.2" r="0.85" className="wn-surf-fill" />
      <circle cx="11.1" cy="8.2" r="0.85" className="wn-surf-fill" />
    </Mark>
  ),
};

export default function NavMark({ name }) {
  const Glyph = MARKS[name];
  if (!Glyph) return null;
  return (
    <span className="cs-nav-mark" aria-hidden="true">
      <Glyph />
    </span>
  );
}
